module.exports = __webpack_public_path__ + "static/s106_large-1fdd42f12773a544ce77580c42cb8fd1.jpg";